import React from 'react';
import styled from 'styled-components';
import { BackButtonContainer, Button, Link } from '../buttons';
import { Icon } from '../icon';
import { Steps } from '../steps';

const PageHeaderWrap = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 16px;
    flex-wrap: wrap;
    position: sticky;
    top: 0px;
    z-index: 2;
    gap: 8px;
    background-color: #f9f9f9;
    padding-top: 16px;
    padding-bottom: 16px;
`;

const PageHeaderBackSteps = styled.div`
    display: flex;
    flex: 1 0 100%;
    padding: 0;

    ${Button} {
        margin-left: 10px;
    }
    ${BackButtonContainer} {
        padding: 0;
        text-transform: none;
        ${Icon} {
            margin-right: 2px;
            margin-left: -7px;
        }
    }
`;
const PageHeaderSteps = styled.div`
    margin-left: auto;
    margin-right: auto;
    line-height: 1.5;
    padding-top: 3px;
    min-height: 26px;
`;
const PageHeaderTitleDescription = styled.div`
    flex: 1 0;
    color: ${(props) => props.theme.app.textColor};
`;
const PageHeaderTitle = styled.h2`
    margin: 0 !important;
    font-size: ${(props) => props.theme.app.component.pageHeader.title.size};
    font-weight: ${(props) => props.theme.app.component.pageHeader.title.weight};
    font-family: ${(props) => props.theme.app.font};
    line-height: ${(props) => props.theme.app.component.pageHeader.lineHeight};
    color: #263238;
`;

const PageHeaderDescription = styled.div<{ $hasDescription: boolean }>`
    padding-block-start: 8px;
    line-height: ${(props) => props.theme.app.component.pageHeader.lineHeight};
    color: #455a64;
    font-size: 13px;

    > a {
        margin-left: ${(props) => (props.$hasDescription ? '4px' : '0')} !important;
    }
`;

const PageHeaderLearnMore = styled(Link)`
    margin-left: 0 !important;
    display: inline-block;
`;

export const PageHeaderButtons = styled.div`
    position: sticky;
    top: 0px;
    z-index: 17;
    background-color: #f9f9f9;
    margin: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

    ${Button} {
        margin-left: 10px;
    }

    ${BackButtonContainer} {
        margin-right: auto;
    }
`;
export const BackAndSteps = styled(PageHeaderButtons)`
    max-width: ${(props) => props.theme.size.container};
    padding: 0 20px 0px 20px;

    ${Steps} {
        width: 100%;
    }
`;

export const FullPageHeaderButtons = styled(PageHeaderButtons)`
    max-width: 100%;
`;

export const PageHeaderButtonsWrap = styled.div`
    display: flex;
    align-items: center;
    align-self: flex-start;
    gap: 8px;
    margin-inline-start: auto;
    flex-shrink: 0;

    ${Button} {
        line-height: 1.4;
    }
`;

const PageHeaderCompactWrap = styled.div`
    position: sticky;
    top: 0px;
    z-index: 2;
    padding: 10px 0 24px;
    background-color: #f9f9f9;
`;

const PageHeaderCompactRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    ${BackButtonContainer} {
        padding: 0;
        text-transform: none;
        ${Icon} {
            margin-right: 2px;
            margin-left: -7px;
        }
    }

    ${PageHeaderTitle} {
        flex: 1;
    }
`;

PageHeaderContainer.BackSteps = PageHeaderBackSteps;
PageHeaderContainer.Steps = PageHeaderSteps;
PageHeaderContainer.TitleDescription = PageHeaderTitleDescription;
PageHeaderContainer.Title = PageHeaderTitle;
PageHeaderContainer.Description = PageHeaderDescription;
PageHeaderContainer.LearnMore = PageHeaderLearnMore;
PageHeaderContainer.Buttons = PageHeaderButtonsWrap;
PageHeaderContainer.CompactWrap = PageHeaderCompactWrap;
PageHeaderContainer.CompactRow = PageHeaderCompactRow;

export function PageHeaderContainer({ children, className }: { children?: React.ReactNode; className?: string }) {
    return <PageHeaderWrap className={className}>{children}</PageHeaderWrap>;
}
